module.exports = __webpack_public_path__ + "public/images/company-logo.eb8caad227965f7269bfa858f17a5137.png";